export default __webpack_public_path__ + "static/media/island.ad332250.svg";